import { FC } from 'react';

import withSchema from 'ia-react-core/~/hocs/schema/withSchema';
import { ParametersExceptFirst } from 'ia-react-core/~/interfaces/ParametersExceptFirst';
import { ActionMap } from 'ia-react-core/~/interfaces/ReducerActions';
import { SnackbarState } from 'ia-react-core/~/interfaces/SnackbarState';

import dismissSnackbarById from '../../../actions/snackbar-fn/dismissSnackbarById';
import notifySnackbarById from '../../../actions/snackbar-fn/notifySnackbarById';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import injectReducer from '../../../hocs/redux/injectReducer';
import compose from '../../../utils/components/_compose';

import Snackbar, { SnackbarComposedProps, SnackbarProps } from './Snackbar';
import snackbarReducer from './Snackbar.reducer';

export * from './Snackbar';

const ComposedSnackbar = compose<FC<SnackbarProps>>(
  withUniqueId('snackbarId'),
  withSchema('snackbar'),
  injectReducer<SnackbarComposedProps, SnackbarState>({
    key: ({ name }) => name,
    idName: 'snackbarId',
    namespace: 'Core/Snackbar',
    identifiers: ({ snackbarId, name }) => ({ snackbarId, name }),
    reducer: snackbarReducer,
    actions: ({ snackbarId: currentSnackbarId }) => ({
      notify: (...args: ParametersExceptFirst<typeof notifySnackbarById>) => notifySnackbarById(currentSnackbarId, ...args),
      dismiss: (...args: ParametersExceptFirst<typeof dismissSnackbarById>) => dismissSnackbarById(currentSnackbarId, ...args),
    }) as ActionMap,
    initialState: ({ snackbarId, name }) => ({
      snackbarId,
      name,
      notifications: [],
    }),
    useScope: true,
    createScope: false,
    cleanState: true,
  }),
)(Snackbar);

ComposedSnackbar.displayName = 'Snackbar';

export default ComposedSnackbar;
